import { useEffect } from "react";

const AuthRedirectHandler = () => {
  // When the component mounts, check if there is a token in the URL
  // We should not keep the token in the URL for security reasons, so we move it to localStorage and strip it out
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.has("token")) {
      const token = params.get("token")!;
      localStorage.setItem("token", token);

      // Remove the token parameter from the search params
      params.delete("token");

      // Rebuild the URL: pathname + query (if any)
      const newQuery = params.toString();
      const newUrl = window.location.pathname + (newQuery ? `?${newQuery}` : "");

      // Update the URL without reloading the page
      window.history.replaceState({}, document.title, newUrl);
    }
  }, []);

  return null;
};

export default AuthRedirectHandler;
